import { render, staticRenderFns } from "./exampleQuestion.vue?vue&type=template&id=17e489df&scoped=true"
import script from "./exampleQuestion.vue?vue&type=script&lang=js"
export * from "./exampleQuestion.vue?vue&type=script&lang=js"
import style0 from "./exampleQuestion.vue?vue&type=style&index=0&id=17e489df&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e489df",
  null
  
)

export default component.exports